import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { StaffComponent } from '../staff/staff.component';

@Component({
  selector: 'app-staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.css']
})
export class StaffListComponent implements OnInit {

  public menu_item_id = '90';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['staff_name', 'staff_mobile1', 'staff_mobile2', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<StaffComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'staff', 'staff_name': '', 'room_type':'' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['staff_name'] != '')
      condition += " (`staff_name` LIKE '%" + this.model['staff_name'] +
        "%' OR `staff_name_en` LIKE '%" + this.model['staff_name'] + "%') AND ";


    let query = "SELECT * FROM `staff` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newStaff() {
    this.addDialogRef = this.dialog.open(StaffComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
      });
  }

  editStaff(row) {
    let dialog_data = {
      'table_name': 'staff', 'staff_id': row.staff_id,
      'staff_name': row.staff_name,
      'staff_name_en': row.staff_name_en,
      'gender': row.gender,
      'staff_mobile1': row.staff_mobile1,
      'staff_mobile2': row.staff_mobile2,
      'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(StaffComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delStaff(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'staff_id': row.staff_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
